exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".controlButtons.lang-level-pill .controlBarButton.vjs-button.level{border-radius:0 10px 10px 0;border-left:none}.controlButtons.lang-level-pill .controlBarButton.vjs-button.level .text{overflow:hidden}\n", ""]);

